export const DOCUMENT_TABS = [
    {
        label: 'Most questioned docs.',
        value: 'sources',
        columns: [
            // { name: 'Document Owner', key: '' },
            { name: 'Document/Source title', key: 'source' },
            { name: 'Questions asked related to doc/source', key: 'count', type: 'number' }
        ],
        linkTitle: 'View more data about sources'
    },
    {
        label: 'Sources of confusion',
        value: 'confusion',
        columns: [
            // { name: 'Document Owner', key: 'documentOwner' },
            { name: 'Document/Source title', key: 'document' },
            { name: 'Confusion triggers', key: 'confusionTrigger', type: 'number' }
        ],
        linkTitle: 'View more'
    },
    {
        label: 'Sentiment of questions',
        value: 'sentiment',
        columns: [
            { name: 'Document/Source title', key: 'document' },
            { name: 'Positive', key: 'positive' },
            { name: 'Neutral', key: 'neutral' },
            { name: 'Negative', key: 'negative' },
        ],
        linkTitle: 'View more'
    },
]